import validator from 'validator';
import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const UrlValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    if (validator.isURL(value, { require_protocol: true })) {
      return { valid: true };
    }

    return {
      valid: false,
      error: errorMessage,
    };
  };
};
